import { useEffect } from "react";

const DEFAULTS = {
  title: "NEXTGEN PERFORMANCE — Coaching. Nutrition. Results.",
  description:
    "Elite personal training, nutrition coaching, and body optimization by ISSA-certified Coach J in Medford, OR — plus research-grade peptide inquiries via NextGen Pro Peptides.",
  image:
    "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/2fb284k0_inbound5678074058752091316.png",
  url: "https://nextgenlifestyle365.com/",
  robots: "index, follow, max-image-preview:large",
};

function upsertMeta({ name, property, content }) {
  if (!content) return;
  const selector = name
    ? `meta[name="${name}"]`
    : `meta[property="${property}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    if (name) el.setAttribute("name", name);
    if (property) el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * SEO — lightweight per-page metadata. Renders nothing.
 * Pass any subset of { title, description, image, url, robots }.
 * Values fall back to site defaults defined at the top of the file.
 */
export default function SEO({ title, description, image, url, robots }) {
  const t = title ? `${title} — NEXTGEN PERFORMANCE` : DEFAULTS.title;
  const d = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const u = url || DEFAULTS.url;
  const r = robots || DEFAULTS.robots;

  useEffect(() => {
    document.title = t;
    upsertMeta({ name: "description", content: d });
    upsertMeta({ name: "robots", content: r });
    upsertMeta({ property: "og:title", content: t });
    upsertMeta({ property: "og:description", content: d });
    upsertMeta({ property: "og:image", content: img });
    upsertMeta({ property: "og:url", content: u });
    upsertMeta({ property: "og:type", content: "website" });
    upsertMeta({ name: "twitter:card", content: "summary_large_image" });
    upsertMeta({ name: "twitter:title", content: t });
    upsertMeta({ name: "twitter:description", content: d });
    upsertMeta({ name: "twitter:image", content: img });
    upsertCanonical(u);
  }, [t, d, img, u, r]);

  return null;
}
